// extracted by mini-css-extract-plugin
export default {"container":"hq-z","brandName":"iq-z","productName":"jq-z","productNamePdpEnhancements":"kq-z","breakLongProductName":"lq-z"};